enum responseType {
    json = 'json',
    text = 'text'
}

enum httpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export {
    responseType,
    httpMethod
}
